(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Index-top-image-over-text-new"] && !Shopify.designMode) return;
  try {
    
	(function () {
		var containers = document.querySelectorAll('[data-hero-video]');
		if (!containers.length) return;

		function pickVariant() {
			var isMobile = window.matchMedia('(max-width: 749px)').matches;
			return isMobile ? 'mobile' : 'desktop';
		}

		containers.forEach(function (container) {
			if (container.dataset.initialized === 'true') return;

			var variant = pickVariant();
			var html =
				variant === 'mobile' ?
					container.dataset.mobileVideoHtml
				:	container.dataset.desktopVideoHtml;

			if (!html) return;

			container.innerHTML = html;
			container.dataset.initialized = 'true';
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["built--cv-gift-quiz"] && !Shopify.designMode) return;
  try {
    
	"use strict";
	(() => {
		// src/sections/cv-gift-quiz/cv-gift-quiz.ts
		var GiftQuiz = class extends HTMLElement {
			abort;
			path = [];
			connectedCallback() {
				this.abort = new AbortController();
				const { signal } = this.abort;
				this.addEventListener("click", (event) => this.handleClick(event), {
					signal
				});
				this.addEventListener(
					"shopify:block:select",
					(event) => this.showSelectedBlock(event),
					{ signal }
				);
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			handleClick(event) {
				if (!(event.target instanceof Element)) return;
				const nextStep = event.target.closest("[data-next-step]")?.dataset.nextStep;
				if (nextStep) this.goForward(nextStep);
				else if (event.target.closest("[data-back]")) this.goBack();
			}
			goForward(handle) {
				const next = this.steps.find((step) => step.dataset.step === handle);
				const current = this.current;
				if (!next || !current) return;
				this.path.push(current);
				this.swap(current, next);
			}
			goBack() {
				const current = this.current;
				const previous = this.path.pop() ?? this.steps[0];
				if (current && previous) this.swap(current, previous);
			}
			showSelectedBlock(event) {
				if (!(event.target instanceof Element)) return;
				const step = event.target.closest("[data-step]");
				if (!step) return;
				this.path = [];
				this.removeAttribute("data-swapped");
				this.steps.forEach((candidate) => {
					candidate.hidden = candidate !== step;
				});
				step.focus();
			}
			swap(from, to) {
				this.setAttribute("data-swapped", "");
				from.hidden = true;
				to.hidden = false;
				to.focus();
			}
			get current() {
				return this.steps.find((step) => !step.hidden);
			}
			get steps() {
				return Array.from(this.querySelectorAll("[data-step]"));
			}
		};
		if (!customElements.get("cv-gift-quiz")) {
			customElements.define("cv-gift-quiz", GiftQuiz);
		}
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["built--cv-header"] && !Shopify.designMode) return;
  try {
    
	"use strict";
	(() => {
		// src/sections/cv-header/cv-header.ts
		var Header = class extends HTMLElement {
			abort = new AbortController();
			triggerModeAbortController = new AbortController();
			desktopTriggers = [];
			drawer;
			drawerBackdrop;
			drawerHamburger;
			closeButton;
			returnToMainMenuButton;
			list;
			drawerContentHolder;
			connectedCallback() {
				this.abort = new AbortController();
				this.triggerModeAbortController = new AbortController();
				this.desktopRelocateDropdowns();
				this.desktopSetupNav();
				this.drawerSetup();
				this.stickySetup();
				this.transparentSetup();
			}
			disconnectedCallback() {
				this.abort.abort();
				this.triggerModeAbortController.abort();
				if (this.drawerIsOpen()) this.drawerClose();
			}
			// ── Desktop nav ──
			desktopRelocateDropdowns() {
				const bar = this.querySelector(".cv-header__desktop-bar");
				if (!bar) return;
				this.querySelectorAll(".cv-header__dropdown").forEach((panel) => {
					bar.appendChild(panel);
				});
			}
			desktopSetupNav() {
				this.desktopTriggers = Array.from(
					this.querySelectorAll(
						".cv-header__nav-trigger[aria-controls]"
					)
				);
				this.desktopTriggers.forEach((trigger) => {
					const item = trigger.closest(".cv-header__nav-section");
					const panel = this.desktopPanelFor(trigger);
					if (!item || !panel) return;
					trigger.addEventListener("keydown", (event) => {
						if (event.key === "Enter" || event.key === " ") {
							event.preventDefault();
							this.desktopToggleDropdown(trigger, panel);
						}
						if (event.key === "Escape") {
							this.desktopCloseAllDropdowns();
							trigger.focus();
						}
					});
				});
				this.desktopSetTriggerMode(this.dataset.triggerMode || "hover");
				document.addEventListener(
					"click",
					(event) => {
						if (!this.contains(event.target))
							this.desktopCloseAllDropdowns();
					},
					{ signal: this.abort.signal }
				);
			}
			desktopSetTriggerMode(mode) {
				this.triggerModeAbortController.abort();
				this.triggerModeAbortController = new AbortController();
				const { signal } = this.triggerModeAbortController;
				this.desktopTriggers.forEach((trigger) => {
					const item = trigger.closest(".cv-header__nav-section");
					const panel = this.desktopPanelFor(trigger);
					if (!item || !panel) return;
					if (mode === "click" || trigger.getAttribute("href") === "") {
						trigger.addEventListener(
							"click",
							(event) => {
								event.preventDefault();
								this.desktopToggleDropdown(trigger, panel);
							},
							{ signal }
						);
					}
					if (mode === "hover") {
						let timeout;
						const open = () => {
							clearTimeout(timeout);
							this.desktopCloseAllDropdowns();
							this.desktopOpenDropdown(trigger, panel);
						};
						const startClose = () => {
							timeout = setTimeout(
								() => this.desktopCloseDropdown(trigger, panel),
								300
							);
						};
						item.addEventListener("mouseenter", open, { signal });
						item.addEventListener("mouseleave", startClose, { signal });
						panel.addEventListener("mouseenter", () => clearTimeout(timeout), {
							signal
						});
						panel.addEventListener("mouseleave", startClose, { signal });
					}
				});
			}
			desktopPanelFor(trigger) {
				const id = trigger.getAttribute("aria-controls");
				return id && document.getElementById(id) || void 0;
			}
			desktopToggleDropdown(trigger, panel) {
				const isOpen = panel.getAttribute("aria-hidden") === "false";
				this.desktopCloseAllDropdowns();
				if (!isOpen) this.desktopOpenDropdown(trigger, panel);
			}
			desktopOpenDropdown(trigger, panel) {
				setDisclosureState(trigger, panel, true);
			}
			desktopCloseDropdown(trigger, panel) {
				setDisclosureState(trigger, panel, false);
			}
			desktopCloseAllDropdowns() {
				this.desktopTriggers.forEach((trigger) => {
					const panel = this.desktopPanelFor(trigger);
					if (panel) this.desktopCloseDropdown(trigger, panel);
				});
			}
			// ── Mobile drawer ──
			drawerSetup() {
				this.drawer = this.find(".cv-header__drawer");
				this.drawerBackdrop = this.find(".cv-header__drawer-backdrop");
				this.drawerHamburger = this.find(".cv-header__hamburger");
				this.closeButton = this.find(".cv-header__drawer-close");
				this.returnToMainMenuButton = this.find(".cv-header__back-to-main-menu");
				if (!this.drawer || !this.drawerHamburger) return;
				this.drawerPopulate(this.drawer);
				this.drawerHamburger.addEventListener("click", () => this.drawerOpen());
				if (this.closeButton)
					this.closeButton.addEventListener("click", () => this.drawerClose());
				if (this.returnToMainMenuButton)
					this.returnToMainMenuButton.addEventListener(
						"click",
						() => this.closeAllSubmenus()
					);
				if (this.drawerBackdrop)
					this.drawerBackdrop.addEventListener("click", () => this.drawerClose());
				document.addEventListener(
					"keydown",
					(event) => {
						if (event.key === "Escape" && this.drawerIsOpen()) this.drawerClose();
					},
					{ signal: this.abort.signal }
				);
			}
			drawerPopulate(drawer) {
				const list = drawer.querySelector(
					".cv-header__drawer-sections"
				);
				const contentHolder = drawer.querySelector(
					".cv-header__drawer-content"
				);
				this.list = list ?? void 0;
				this.drawerContentHolder = contentHolder ?? void 0;
				if (!list || !contentHolder) return;
				list.replaceChildren();
				this.querySelectorAll(".cv-header__nav-section").forEach((section) => {
					const trigger = section.querySelector(
						".cv-header__nav-trigger"
					);
					if (!trigger) return;
					const title = (trigger.textContent ?? "").trim();
					const panel = this.desktopPanelFor(trigger);
					const item = document.createElement("li");
					if (panel) {
						item.appendChild(this.drawerBuildDisclosure(title, panel));
					} else {
						const link = document.createElement("a");
						link.href = (trigger.closest("a") || trigger).href || "#";
						link.textContent = title;
						item.appendChild(link);
					}
					list.appendChild(item);
				});
			}
			drawerBuildDisclosure(title, panel) {
				const summary = document.createElement("div");
				summary.textContent = title;
				summary.className = "cv-header__drawer-section-summary";
				const arrow = document.createElement("div");
				arrow.innerHTML = document.querySelector(".cv-header__arrow-right")?.innerHTML ?? "";
				summary.appendChild(arrow);
				const contentWrapper = document.createElement("div");
				contentWrapper.className = "cv-header__menu-section-wrapper";
				contentWrapper.id = `${title}-menu-items`;
				const inner = panel.querySelector(".cv-header__dropdown-inner");
				if (inner) {
					const clone = inner.cloneNode(true);
					const innerContent = document.createElement("div");
					innerContent.className = "cv-header__menu-section-inner";
					const stack = clone.querySelector(".cv-stack");
					if (stack) {
						const submenuItems = Array.from(stack.children).filter(
							(child) => !child.classList.contains("cv-header__nav-promo")
						);
						submenuItems.forEach((child, index) => {
							child.classList.add("cv-header__submenu-section");
							innerContent.appendChild(child);
							if (index !== submenuItems.length - 1) {
								const divider = document.createElement("div");
								divider.innerHTML = "&nbsp;";
								divider.className = "cv-header__divider";
								innerContent.append(divider);
							}
						});
					}
					if (innerContent.children.length)
						contentWrapper.appendChild(innerContent);
				}
				summary.addEventListener("click", () => {
					contentWrapper.classList.add("cv-header__menu-section-open");
					this.list?.classList.add("cv-header__drawer-sections-hidden");
					if (this.closeButton) this.closeButton.style.display = "none";
					if (this.returnToMainMenuButton)
						this.returnToMainMenuButton.style.display = "flex";
				});
				this.drawerContentHolder?.appendChild(contentWrapper);
				return summary;
			}
			closeAllSubmenus() {
				document.querySelectorAll(".cv-header__menu-section-open").forEach((openDrawer) => {
					openDrawer.classList.remove("cv-header__menu-section-open");
				});
				this.list?.classList.remove("cv-header__drawer-sections-hidden");
				if (this.closeButton) this.closeButton.style.display = "flex";
				if (this.returnToMainMenuButton)
					this.returnToMainMenuButton.style.display = "none";
			}
			drawerIsOpen() {
				return this.drawer?.getAttribute("aria-hidden") === "false";
			}
			drawerOpen() {
				if (!this.drawerHamburger || !this.drawer) return;
				setDisclosureState(this.drawerHamburger, this.drawer, true);
			}
			drawerClose() {
				if (!this.drawerHamburger || !this.drawer) return;
				setDisclosureState(this.drawerHamburger, this.drawer, false);
				this.closeAllSubmenus();
			}
			// ── Sticky ──
			stickySetup() {
				const stickyType = this.dataset.stickyType;
				if (stickyType === "none") return;
				const stickyWrapper = this.closest(".cv-header-section");
				if (!stickyWrapper) return;
				stickyWrapper.classList.add("cv-header-section--sticky");
				if (stickyType === "always") return;
				let lastScrollTop = 0;
				stickyWrapper.style.setProperty(
					"--cv-header-height",
					`${this.offsetHeight}px`
				);
				window.addEventListener(
					"scroll",
					() => {
						const scrollTop = window.scrollY;
						if (scrollTop > lastScrollTop && scrollTop > this.offsetHeight) {
							stickyWrapper.classList.add("cv-header-section--hidden");
						} else {
							stickyWrapper.classList.remove("cv-header-section--hidden");
						}
						lastScrollTop = scrollTop;
					},
					{ passive: true, signal: this.abort.signal }
				);
			}
			// ── Transparent ──
			transparentSetup() {
				if (!this.classList.contains("cv-header--transparent")) return;
				const sentinel = document.createElement("div");
				sentinel.className = "cv-header__top-sentinel";
				sentinel.setAttribute("aria-hidden", "true");
				(this.closest(".cv-header-section") ?? this).before(sentinel);
				const observer = new IntersectionObserver((entries) => {
					const beforeStickPoint = entries[entries.length - 1]?.isIntersecting ?? true;
					this.classList.toggle("cv-header--scrolled", !beforeStickPoint);
				});
				observer.observe(sentinel);
				this.abort.signal.addEventListener("abort", () => {
					observer.disconnect();
					sentinel.remove();
				});
			}
			find(selector) {
				return this.querySelector(selector) ?? void 0;
			}
		};
		function setDisclosureState(trigger, panel, isOpen) {
			trigger.setAttribute("aria-expanded", String(isOpen));
			panel.setAttribute("aria-hidden", String(!isOpen));
		}
		if (!customElements.get("cv-header")) {
			customElements.define("cv-header", Header);
		}
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["built--cv-rebuy-recommendations"] && !Shopify.designMode) return;
  try {
    
	"use strict";
	(() => {
		// src/utilities/dom.ts
		function requireElement(selector, root = document) {
			const element = root.querySelector(selector);
			if (!element) {
				throw new Error(`requireElement: no element matches "${selector}"`);
			}
			return element;
		}

		// src/sections/cv-rebuy-recommendations/cv-rebuy-recommendations.ts
		var RebuyRecommendations = class extends HTMLElement {
			abort;
			connectedCallback() {
				this.abort = new AbortController();
				const { signal } = this.abort;
				const readyWidget = window.Rebuy?.widgets?.find(
					(widget) => this.isOurs(widget) && widget.status === "ready"
				);
				if (readyWidget) {
					void this.show(readyWidget, signal);
					return;
				}
				const onReady = (event) => {
					const { widget } = event.detail ?? {};
					if (!widget || !this.isOurs(widget)) return;
					document.removeEventListener("rebuy.ready", onReady);
					void this.show(widget, signal);
				};
				document.addEventListener("rebuy.ready", onReady, { signal });
			}
			disconnectedCallback() {
				this.abort?.abort();
			}
			async show(widget, signal) {
				const handles = (widget.data?.products ?? []).flatMap(
					(product) => product.handle ? [product.handle] : []
				);
				await customElements.whenDefined("cv-product-carousel");
				const carousel = requireElement(
					"cv-product-carousel",
					this
				);
				let count = 0;
				try {
					if (handles.length > 0) {
						count = await carousel.showHandles(handles, { signal });
					}
				} catch (error) {
					if (signal.aborted) return;
					console.error("[cv-rebuy-recommendations] cards failed:", error);
				}
				if (count === 0) {
					(this.closest(".shopify-section") ?? this).hidden = true;
					return;
				}
				addDiscoveryParameters(carousel, String(widget.id));
			}
			isOurs(widget) {
				return String(widget.id) === this.dataset.widgetId;
			}
		};
		function addDiscoveryParameters(root, widgetId) {
			root.querySelectorAll("a[href]").forEach((link) => {
				const url = new URL(link.href, window.location.origin);
				const handle = url.pathname.match(/\/products\/([^/]+)/)?.[1];
				if (!handle) return;
				url.searchParams.set("_rdiscovery-handle", handle);
				url.searchParams.set("_rdiscovery-widget", widgetId);
				link.href = url.pathname + url.search + url.hash;
			});
		}
		if (!customElements.get("cv-rebuy-recommendations")) {
			customElements.define("cv-rebuy-recommendations", RebuyRecommendations);
		}
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cv-collage-grid"] && !Shopify.designMode) return;
  try {
    
	(function () {
		function alignCollageImage(grid) {
			var imageEl = grid.querySelector('.cv-collage-grid__image');
			if (!imageEl) return;

			if (!window.matchMedia('(min-width: 750px)').matches) {
				imageEl.style.height = '';
				return;
			}

			var mediaEls = grid.querySelectorAll(
				'.cv-collage-grid__product .cv-product-card__media'
			);
			if (!mediaEls.length) return;

			var lastMedia = mediaEls[mediaEls.length - 1];
			var gridTop = grid.getBoundingClientRect().top;
			var lastMediaBottom = lastMedia.getBoundingClientRect().bottom;
			var height = lastMediaBottom - gridTop;

			if (height > 0) {
				imageEl.style.height = height + 'px';
			}
		}

		function alignAllCollageGrids() {
			document.querySelectorAll('.cv-collage-grid').forEach(alignCollageImage);
		}

		var resizeTimer;
		function onResize() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(alignAllCollageGrids, 100);
		}

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', alignAllCollageGrids);
		} else {
			alignAllCollageGrids();
		}
		window.addEventListener('load', alignAllCollageGrids);
		window.addEventListener('resize', onResize);

		// Re-run whenever the Theme Editor swaps in fresh section markup
		// (e.g. after a settings change), since that doesn't trigger a page load.
		document.addEventListener('shopify:section:load', function (event) {
			var grid = event.target.querySelector('.cv-collage-grid');
			if (grid) {
				requestAnimationFrame(function () {
					alignCollageImage(grid);
				});
			}
		});
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
